export default new (class ConvertDate {
  getDate(timestamp: number, locale: string, format: string) {
    try {
      const date = new Date(Number(timestamp) * 1000);
      if (locale === "ja-jp" || locale === "zh-tw") {
        return this.formatDate(date, format);
      } else {
        return date.toLocaleDateString(locale, {
          year: "numeric",
          month: "short",
          day: "numeric"
        });
      }
    } catch (e) {
      return e;
    }
  }

  /**
   * フォーマットから日付を変換表示
   */
  formatDate(date: Date, format: string): string {
    const yyyy = date.getFullYear();
    const mm = ("0" + (date.getMonth() + 1)).slice(-2);
    const dd = ("0" + date.getDate()).slice(-2);
    const hh = ("0" + date.getHours()).slice(-2);
    const mi = ("0" + date.getMinutes()).slice(-2);

    format = format.replace(/yyyy/g, yyyy + "");
    format = format.replace(/M/g, mm);
    format = format.replace(/d/g, dd);
    format = format.replace(/H/g, hh);
    format = format.replace(/m/g, mi);
    format = format.replace(/s/g, String(date.getSeconds()));
    format = format.replace(/S/g, String(date.getMilliseconds()));

    return format;
  }
})();
